/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { IInspectorControl_Secret, TInspectorControlProps } from "../InspectorControlTypes";
import { FieldGroup, FieldSecret } from "@adapptio/lib-editor-ui";
import { useBlueprintModel } from "../../../ui/hooks";

export interface IInspectorControlSecretProps extends TInspectorControlProps<IInspectorControl_Secret> {}

export const InspectorControlSecret: React.FC<IInspectorControlSecretProps> = ({ model: _model }) => {
	const { model, validationErrors } = useBlueprintModel(_model, "constSecret");

	const handleChange = useCallback(
		(value: string) => {
			if (!model) {
				return;
			}

			model.schema.setValue(model, value, true);
		},
		[ model ]
	);

	return (
		<FieldGroup grow>
			<FieldSecret
				key={model.nodeId}
				secretKey={model.value}
				onChange={handleChange}
				validationErrors={validationErrors}
				grow
			/>
		</FieldGroup>
	);
};
